<template>
  <a class="btn btn-secondary cta fs-sm border-0" target="_blank" :href="settings.cta_url || '#'">
    {{ settings.cta }}
  </a>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { SectionSettings } from './types'
import { getColorById } from './utils'

interface Props {
  settings: SectionSettings
}

const props = withDefaults(defineProps<Props>(), {
  settings: () =>
    ({
      cta: 'Learn more',
      cta_url: '#',
      design_settings: {
        colors: [],
      },
    }) as SectionSettings,
})

const buttonColor = computed(() =>
  getColorById(props.settings.design_settings?.colors, 'button_color'),
)

const buttonTextColor = computed(() =>
  getColorById(props.settings.design_settings?.colors, 'button_text_color'),
)
</script>

<style scoped lang="sass">
.btn.cta
  padding: 0.3rem 2rem
  max-width: 300px
  text-overflow: ellipsis
  overflow: hidden
  white-space: nowrap
  background-color: v-bind(buttonColor)
  color: v-bind(buttonTextColor)
  transition: all 0.2s ease

  &:hover, &:active, &:focus
    background-color: v-bind(buttonColor)
    color: v-bind(buttonTextColor)
    filter: brightness(1.1)
</style>
